import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { PopupInterface } from 'common/types/entities/popup-interface'
import {
  generateHtmlAttrId,
  generateId,
} from 'client/utils/createStructureUtils'

export const createPopup = (): PopupInterface => {
  return {
    id: generateId(),
    htmlAttrId: generateHtmlAttrId(EntityTypeEnum.Popup),
    type: EntityTypeEnum.Popup,

    border: {
      color: 'rgba(74, 144, 226, 1)',
      style: 'solid',
      width: 3,
      radius: 6,
    },
    boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2)',
    background: 'rgba(255, 255, 255, 1)',
    padding: {
      paddingBottom: 30,
      paddingTop: 30,
      paddingLeft: 30,
      paddingRight: 30,
    },
    mobilePadding: {
      paddingBottom: 10,
      paddingTop: 10,
      paddingLeft: 10,
      paddingRight: 10,
    },
    showClose: false,
    openAutomatically: true,
    openOnMobileAutomatically: false,
    delay: 1,
    mobileDelay: 1,
    childIds: [],
  }
}
